var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"success-title flex flex-x flex-y"},[_c('van-icon',{attrs:{"name":"success"}}),_vm._v("扫码成功 ")],1),_c('div',{staticClass:"qrcode"},[_c('img',{attrs:{"src":_vm.qrcode}})]),_c('div',{staticClass:"identify"},[_vm._v("长按识别二维码关注公众号")]),_c('div',{staticClass:"identify"},[_vm._v("即可随时查看报告！")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }